
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { useConstructionMode } from '@/contexts/ConstructionModeContext';
import { useToast } from '@/hooks/use-toast';
import { useUserRole } from '@/hooks/useUserRole';
import { Settings } from 'lucide-react';

const ConstructionModeToggle = () => {
  const { isConstructionMode, toggleConstructionMode } = useConstructionMode();
  const { toast } = useToast();
  const { isAdmin, loading } = useUserRole();
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    toggleConstructionMode();
    toast({
      title: isConstructionMode ? "Modo construcción desactivado" : "Modo construcción activado",
      description: isConstructionMode 
        ? "El sitio ahora está disponible para los usuarios" 
        : "El sitio ahora muestra la página de construcción",
    });
    setIsOpen(false);
  };

  // Only show the toggle for admin users - this is the security gate
  if (loading || !isAdmin) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="fixed bottom-4 right-4 opacity-30 hover:opacity-100 transition-opacity z-50"
          title="Admin: Toggle Construction Mode"
        >
          <Settings className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isConstructionMode ? "Desactivar" : "Activar"} Modo Construcción
          </DialogTitle>
          <DialogDescription>
            {isConstructionMode 
              ? "El sitio volverá a estar disponible normalmente"
              : "El sitio mostrará la página de construcción a todos los usuarios"
            }
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end space-x-2 pt-4">
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancelar
          </Button>
          <Button onClick={handleToggle}>
            {isConstructionMode ? "Desactivar" : "Activar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConstructionModeToggle;
